import '../css/app.scss';
import Anchors from './components/anchors';
import Gallery from './components/gallery';
import Header from './components/header';
import Hero from './components/hero';
import Navigation from './components/navigation';
import Scroll from './components/scroll';
import ScrollTrigger from "gsap/ScrollTrigger";


/** Global Components */

/** Bootstrap */

$(() => {
const $textReveal      = $('[data-scroll="text-reveal"]');
const $textRevealGroup = $('[data-scroll="text-reveal-group"]');
const $fadeIn           = $('[data-scroll="fade-in"]');
const $scrollImages     = $('[data-scroll="image"]');



	const $nav = $('[data-nav="el"]');
		new Navigation($nav);

	const $header = $('[data-header="el"]');
	new Header($header);

	const $anchors = $('[data-anchors="el"]');
	if($anchors.length) {
			new Anchors($anchors);
	}


	const $gallery = $('[data-gallery="el"]');
	if($gallery.length) {
		new Gallery($gallery);
	}

	const $hero = $('[data-hero="el"]')
if ($hero.length) new Hero($hero);
new Scroll($textReveal, $textRevealGroup, $fadeIn);

requestAnimationFrame(() => {
  requestAnimationFrame(() => {
    ScrollTrigger.refresh();
  });
});
});
